import { DEFAULT_LOCALE } from '@npi/buddy-utils';
import { IntlConfig } from 'react-intl';

import { getCurrencyCodeFromLocaleLanguage } from 'src/utils/locales/locale-to-currency';
import { isTestingWithJest } from 'src/utils/test-utils';

export const getDefaultIntlConfig = (navigatorLanguage: string): IntlConfig => {
    // Use the navigator language to test the component can handle different locales for future requirements
    // use DEFAULT_LOCALE until this is properly implemented as we currently don't have currency conversion or multi-currency
    const defaultIntlConfigLocale = isTestingWithJest() ? navigatorLanguage : DEFAULT_LOCALE;

    const intlConfig = {
        locale: defaultIntlConfigLocale,
        currency: getCurrencyCodeFromLocaleLanguage(defaultIntlConfigLocale),
    };

    return intlConfig;
};

export default { getDefaultIntlConfig };
